import type { ReactNode } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface DomainCardProps {
	icon: ReactNode;
	title: string;
	description: string;
	available: boolean;
	connectionCount?: number;
	onClick?: () => void;
}

export function DomainCard({
	icon,
	title,
	description,
	available,
	connectionCount,
	onClick,
}: DomainCardProps) {
	return (
		<Card
			className={cn(
				'relative min-h-[210px] cursor-pointer border transition-shadow hover:shadow-md',
				!available && 'cursor-default opacity-65',
			)}
			onClick={available ? onClick : undefined}
		>
			{!available && (
				<span className="absolute right-3 top-3 rounded bg-muted px-2 py-0.5 text-xs text-muted-foreground">
					Coming soon
				</span>
			)}
			<CardContent className="flex flex-col gap-3 p-7">
				<div className="text-muted-foreground">{icon}</div>
				<h3 className="text-lg font-semibold">{title}</h3>
				<p className="text-sm text-muted-foreground">{description}</p>
				{available && connectionCount !== undefined && (
					<p className="text-xs text-muted-foreground">
						{connectionCount} connections configured
					</p>
				)}
			</CardContent>
		</Card>
	);
}
